import { connect } from 'react-redux';

import ParticipantDescription from './ParticipantDescription';
import { selectors } from '../../../../store/groups';
import { isInstructor } from '../../../../../core/selectors/classroom';

const mapStateToProps = (state, props) => ({
  groupNames: selectors.groupNamesByStudentId(state, props.userId),
  isInstructor: isInstructor(state, props.userId),
});

export default connect(mapStateToProps)(ParticipantDescription);
